/* ============================================================================
   גודל הטקסט של הפלטפורמה — העדפת מכשיר (localStorage, לא נשמרת בחשבון),
   כמו זום דפדפן שזמין מתוך ההגדרות.

   ההגדלה נעשית ב-zoom על שורש המסמך: הטקסט וכל מיכל שסביבו גדלים באותו
   יחס, ולכן טקסט לעולם לא חורג מהמקום שבו הוא יושב — הפריסה הרספונסיבית
   פשוט מתנהגת כמו מסך צר יותר. הגדלת גופנים בלבד הייתה שוברת שדות
   וכרטיסים שמידותיהם בפיקסלים.
   ============================================================================ */

const KEY = "rentals:text-scale";

export const TEXT_SCALES = [
  { v: 1, label: "רגיל" },
  { v: 1.1, label: "גדול" },
  { v: 1.25, label: "גדול מאוד" },
];

export const textScale = () => {
  try {
    const v = Number(localStorage.getItem(KEY));
    return TEXT_SCALES.some((s) => s.v === v) ? v : 1;
  } catch {
    return 1;
  }
};

export const applyTextScale = (v = textScale()) => {
  try {
    document.documentElement.style.zoom = v === 1 ? "" : String(v);
  } catch { /* דפדפן בלי zoom — נשארים בגודל הרגיל */ }
};

export const setTextScale = (v) => {
  try {
    if (v === 1) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, String(v));
  } catch { /* מצב פרטי — יחול עד סגירת הלשונית */ }
  applyTextScale(v);
  // מי שמחשב מידות לפי הזום (העוזר) מתעדכן מיד, לא רק ברענון הבא.
  try { window.dispatchEvent(new Event("rentals:text-scale")); } catch { /* SSR */ }
};
